import React from 'react';
import { renderSortingIcons } from 'app/shared/util/table-util';
import { PaginationState } from 'app/shared/pagination/pagination.model';
import './view-table.scss';

export interface IViewTableHeaderColumnProps {
  renderSort: boolean;
  columnLabels: string[];
  sortKey?: string;
  sortFunction?: (event: React.MouseEvent<HTMLDivElement>) => void;
  pagination?: PaginationState;
  children?: React.ReactNode;
  width?: string;
  compactColumn?: boolean;
}

const ViewTableHeaderColumn = ({ renderSort, columnLabels, sortKey, sortFunction, pagination, width, compactColumn }: IViewTableHeaderColumnProps) => {
  return (
    <th className={compactColumn ? 'compact-column' : ''} style={{ width: width ?? '' }}>
      {columnLabels?.length > 1 && (
        <div className="column-with-multiple-data">
          {columnLabels.map((label, index) => (
            <span key={index}>{label}</span>
          ))}
        </div>
      )}
      {columnLabels?.length === 1 && <span>{columnLabels[0]}</span>}
      {renderSort && renderSortingIcons(sortKey, pagination, sortFunction)}
    </th>
  );
};

export default ViewTableHeaderColumn;
